import { createContext, useContext } from 'react';

/** Id of the text naming the engine's quantity behind an overridden Qty. */
export const CalculatedDescriptionContext = createContext<string | undefined>(
  undefined,
);

export function useCalculatedDescriptionId() {
  return useContext(CalculatedDescriptionContext);
}
